import type { AnalyticsEventData } from './types';

const MAX_EVENT_NAME = 50;
const MAX_STRING = 500;
const MAX_PROPERTIES = 50;

/** -- Normalize payloads for Umami / GA limits. */
export function sanitizeEventName(name: string): string {
  return name.trim().slice(0, MAX_EVENT_NAME);
}

export function sanitizeEventData(
  data: AnalyticsEventData | undefined
): AnalyticsEventData | undefined {
  if (!data) return undefined;

  const out: AnalyticsEventData = {};
  let count = 0;

  for (const [key, raw] of Object.entries(data)) {
    if (count >= MAX_PROPERTIES) break;
    if (raw === undefined || raw === null) continue;

    const k = key.trim().slice(0, 50);
    if (!k) continue;

    if (typeof raw === 'boolean') {
      out[k] = raw;
    } else if (typeof raw === 'number') {
      out[k] = Number.isFinite(raw) ? Number(raw.toPrecision(4)) : 0;
    } else {
      out[k] = String(raw).slice(0, MAX_STRING);
    }
    count += 1;
  }

  return Object.keys(out).length > 0 ? out : undefined;
}
